import { TotemToastPlugin } from '@totem/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

import type { SoaConfig } from '@/core/lib/Config';
import ActualitesPlugin from '@/plugins/actualites';
import AnnoncesPlugin from '@/plugins/annonces';
import ApmAgentPlugin from '@/plugins/apmAgent';
import AuthenticationPlugin from '@/plugins/authentication';
import { type AuthenticationState, listenFor, setTokenAsRefreshed } from '@/plugins/authentication/lib/Authentication';
import AxeptioPlugin from '@/plugins/axeptio';
import ClientsPlugin from '@/plugins/clients';
import DocumentationPlugin from '@/plugins/documentation';
import GtmTrackerPlugin from '@/plugins/gtmTracker';
import { assertGtmIdList, trackAuthSuccess } from '@/plugins/gtmTracker/lib/GtmTracker';
import LayoutPlugin from '@/plugins/layout';
import ProjetsPlugin from '@/plugins/projets';

interface RegisterPluginsOptions {
  app: App<Element>;
  router: Router;
  config: SoaConfig;
}

export function registerPlugins({ app, router, config }: RegisterPluginsOptions): void {
  app.use(AuthenticationPlugin, {
    config,
    listeners: [
      listenFor(['success'], (state: AuthenticationState) => {
        if (!state.user) {
          throw new Error('Utilisateur introuvable.');
        }

        trackAuthSuccess(state.user);
      }),
      listenFor(['refreshSuccess'], async () => {
        await setTokenAsRefreshed();
      }),
    ],
  });

  app.use(GtmTrackerPlugin, {
    id: ((gtmIdList: (string | undefined)[]) => {
      // Ensure environment variables are defined and not empty
      assertGtmIdList(gtmIdList);

      return gtmIdList;
    })([import.meta.env.VITE_APP_GTM_ESPACEPRO_EDA_ID as string]),
    enabled: import.meta.env.MODE === 'production',
    debug: false,
    loadScript: true,
  });

  app.use(AxeptioPlugin);

  app.use(ApmAgentPlugin, {
    router,
    config: {
      ...config.apmAgent,
      serviceName: 'distribution-espace-distributeur',
      serviceVersion: import.meta.env.VITE_APP_VERSION as string,
    },
  });

  app.use(TotemToastPlugin);

  app.use(LayoutPlugin);
  app.use(ActualitesPlugin);
  app.use(AnnoncesPlugin);
  app.use(ClientsPlugin);
  app.use(DocumentationPlugin);
  app.use(ProjetsPlugin);
}
